// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { RoleDetailsFacadeService } from '@app/access-management/state/role-details.facade';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  Role,
  readParameterFromRouterState,
  GoAction,
  IAM_ROUTE,
  RolesService
} from '@app/core';
import {
  State,
  SelectUsersForRoleAction,
  ClearRoleUserSelectionsAction,
} from '../../state';
import { SelectedRows } from '@app/shared/data-table-ajax/data-table-ajax.component';

@Component({
  selector: 'app-role-users-form',
  templateUrl: './role-users-form.component.html',
  styleUrls: ['./role-users-form.component.scss']
})
export class RoleUsersFormComponent implements OnInit {

  role$: any;
  roleUsers$: any;

  selectedUsers: any = [];
  private roleId: string;

  userTableColumns = [
    { name: 'Username', prop: 'username'},
    { name: 'Name', prop: 'name'},
    { name: 'Email', prop: 'email'},
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private roleDetailsFacadeService: RoleDetailsFacadeService,
    private roleService: RolesService,
    private store: Store<State>) {
    const roleId = readParameterFromRouterState(this.activatedRoute, 'id');
    if (!roleId) {
      throw new Error('role id not in route');
    }
    this.roleId = roleId;

    this.roleDetailsFacadeService.initialize(this.roleId);

    this.role$ = this.roleDetailsFacadeService.role$;
    this.roleUsers$ = this.roleService.getRoleUsers(this.roleId);
  }

  ngOnInit() {}

  onSelectUser({ selected }: SelectedRows) {
    this.selectedUsers = selected;
  }

  isValid () {
    return this.selectedUsers && this.selectedUsers.length;
  }

  selectUsers() {
    if (!this.isValid()) {
      return;
    }

    this.store.dispatch(
      new SelectUsersForRoleAction({
        roleId: this.roleId,
        selectedUsers: this.selectedUsers
      })
    );
  }

  cancel() {
    this.store.dispatch(new ClearRoleUserSelectionsAction(this.roleId));
    this.goToRoleDetailsPage();
  }

  private goToRoleDetailsPage() {
    this.store.dispatch(new GoAction(['/', IAM_ROUTE, 'roles', this.roleId]));
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-users-form/role-users-form.component.ts